export default function dependency(name, version, main) {
  return {
    resolve: function resolve() {
      var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : main;
      return "https://cdn.jsdelivr.net/npm/".concat(name, "@").concat(version, "/").concat(path);
    }
  };
}